import { attributesToProps, domToReact } from "html-react-parser"
import Text from "./styles/typography"
import { Link } from "gatsby"
import { css } from "@emotion/react"
import { fontSizes } from "./styles/theme"
import ArticleFigure from "./components/ArticleFigure"
import ArticleImage from "./components/ArticleImage"

const options = () => {
  return {
    replace: domNode => {
      if (["p", "blockquote"].includes(domNode.name)) {
        const props = attributesToProps(domNode.attribs)
        return (
          <Text {...props} el={domNode.name}>
            {domToReact(domNode.children, options())}
          </Text>
        )
      }
      if (domNode.name === "a") {
        const props = attributesToProps(domNode.attribs)
        const isRelativeLink = props?.href?.charAt(0) === "/"
        if (isRelativeLink) {
          props.to = props.href
          delete props.href
        }
        return (
          <Text {...props} el={isRelativeLink ? Link : "a"}>
            {domToReact(domNode.children, options())}
          </Text>
        )
      }
      if (["h1", "h2", "h3", "h4", "h5", "h6"].includes(domNode.name)) {
        const props = attributesToProps(domNode.attribs)
        const hLevel = parseInt(domNode.name.charAt(1))
        return (
          <Text {...props} el={`h${hLevel === 6 ? 6 : hLevel + 1}`}>
            {domToReact(domNode.children, options())}
          </Text>
        )
      }
      if (["figcaption"].includes(domNode.name)) {
        const props = attributesToProps(domNode.attribs)
        const isQuote =
          domNode.parent.name === "figure" &&
          domNode.parent.children.find(({ name }) => name === "blockquote")
        return (
          <Text {...props} el={domNode.name} alert={domNode.parent.children}>
            {isQuote && `— `}
            {domToReact(domNode.children, options())}
          </Text>
        )
      }
      if (domNode.name === "li") {
        const props = attributesToProps(domNode.attribs)
        const strippedChildNodes = domNode.children.flatMap(child =>
          child.name === "p" ? child.children : [child]
        )
        return (
          <Text {...props} el={domNode.name}>
            {domToReact(strippedChildNodes, options())}
          </Text>
        )
      }
      if (domNode.name === "figure") {
        const props = attributesToProps(domNode.attribs)
        const strippedChildNodes = domNode.children.flatMap(child =>
          child.name === "p" ? child.children : [child]
        )
        return (
          <ArticleFigure
            {...props}
            css={css`
              margin: 16px 0;
            `}
          >
            {domToReact(strippedChildNodes, options())}
          </ArticleFigure>
        )
      }
      if (domNode.name === "img") {
        const props = attributesToProps(domNode.attribs)

        return <ArticleImage {...props} />
      }
    },
  }
}

export default options
